import { render, staticRenderFns } from "./PopupReviewDetail.vue?vue&type=template&id=5626c3b2&scoped=true&"
import script from "./PopupReviewDetail.vue?vue&type=script&lang=ts&"
export * from "./PopupReviewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PopupReviewDetail.vue?vue&type=style&index=0&id=5626c3b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626c3b2",
  null
  
)

export default component.exports